import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import logo from "../../assets/images/logo.png";
import { formatTodayDateTime2 } from '../helpers/formatted-dates';


const LoginOtp = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);

   // const [passEye, setPassEye] = useState(false);
    const [inputData, setInputData] = useState({
        email: "",
        otp: "",
    });
    useEffect(() => {

        if (localStorage.getItem('@user_email'))
            setInputData({ ...inputData, email: localStorage.getItem('@user_email') })
        else
            navigate("/login");


    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(null);

        const { email, otp ,remember_me} = inputData;
        if (!email || !otp) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);
            
            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/login-otp", {
                email: email,
                otp: otp,
                remember_me: remember_me,
                current_time : formatTodayDateTime2()
            },{
                headers: {
                  'Content-Type': 'application/json'
                },
                withCredentials: true
              })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        
                        localStorage.setItem("@user_role", response.data.user.role)
                        localStorage.setItem("@audit_id", response.data.audit_id);
                        
                        localStorage.setItem("@user_email", email)
                        if (response.data.user.role === 1){

                            localStorage.setItem('@first_name', response.data.user.first_name);
                            localStorage.setItem('@last_name', response.data.user.last_name);
                            localStorage.setItem('@admin_role', response.data.user.admin_role);

                            navigate("/admin/work-orders-active");

                        }
                        else if(response.data.user.role === 2){

                            localStorage.setItem('@first_name', response.data.user.first_name);
                            localStorage.setItem('@last_name', response.data.user.last_name);
                            navigate("/client/work-orders-active");

                        }
                        else if(response.data.user.role === 3)
                        {
                            localStorage.setItem('@first_name', response.data.user.case_manager_first_name);
                            localStorage.setItem('@last_name', response.data.user.case_manager_last_name);
                            navigate("/case-manager/work-orders-active");
                        }
                    } else {

                        setErrorResponse(response?.data?.message);

                    }
                })
                .catch(function (error) {

                    setIsBtn(false)
                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    return (
        <div className="card card-medium" >
            <div className="card-header">
                <img src={logo} alt="MedRecAps" />
            </div>
            <div className="card-body p-4">
                <form onSubmit={(e) => handleLogin(e)}>

                    <h5 className="text-center mb-5 text-primary">The authorization code you requested has been sent to {inputData.email} and will expire after 5 Minutes. </h5>
                    {errorResponse &&
                        <div className="alert alert-danger" role="alert">
                            {errorResponse}
                        </div>
                    }

                    <div className="row mt-2">
                        <div className="col-12">

                            <div className="input-group">
                                <input type="text" className="form-control form-control-lg" id="password"
                                    name="otp" value={inputData.otp}
                                    onChange={(e) =>
                                        setInputData({ ...inputData, otp: e.target.value })
                                    } />
                            </div>
                            {inputError && !inputData.otp && (
                                <span className="text-danger">This field is required</span>
                            )}

                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12 text-end">

                            <div className="input-group align-items-end">
                                <input type="checkbox" className="form-check-input me-1" id="remember_me"
                                    name="remember_me" value="1"
                                    checked={inputData.remember_me?true:false}
                                    onChange={(e) =>
                                        setInputData({ ...inputData, remember_me: !inputData.remember_me })
                                    } />
                                    <label className="form-check-label fw-bold text-primary">Private Computer Keep Me Signed in For 8 Hours</label>
                            </div>
                          

                        </div>
                    </div>

                    <div className=" text-center ">

                        <button type="submit" className="btn btn-lg btn-primary mt-3 mb-3 px-5" disabled={isBtn}>
                            {isBtn ? <Loading /> : 'Login'}
                        </button>

                        <div >
                            <Link className="btn btn-link text-primary mt-5" to="/login">Go to Login Page</Link>
                        </div>

                    </div>


                </form>
            </div>
        </div>


    );
};

export default LoginOtp;